import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Space, Typography } from 'antd';

const { Title, Text } = Typography;

const AnnouncementInfo = ({ data, title }) => {
  const formatTrainerLink = (trainer) => {
    const name = `${trainer?.firstName} ${trainer?.lastName}`;
    return <Link to={`/trainer/${trainer?.trainerId}`}>{name} </Link>;
  };

  const renderSupportinStaffLinks = (staff) => {
    const staffLinks = Children.toArray(
      staff.map((item) => formatTrainerLink(item))
    );

    return <div>{staffLinks}</div>;
  };
  const renderItems = () => {
    const formattedData = [
      {
        label: 'Course Offer Code',
        value: <Link to={data?.link}>{data?.courseOfferCode}</Link>,
      },
      {
        label: 'Course Name',
        value: <Link to={data?.courseLink}>{data?.course}</Link>,
      },
      {
        label: 'Start Date',
        value: data?.startDate,
      },
      {
        label: 'End Date',
        value: data?.endDate,
      },
      {
        label: 'Start Time',
        value: data?.startTime,
      },
      {
        label: 'End Time',
        value: data?.endTime,
      },
      {
        label: 'Frequency',
        value: (
          <span>
            {Children.toArray(data?.frequency?.map((text) => `${text} `))}
          </span>
        ),
      },
      {
        label: 'Lead Trainer',
        value: data?.selectedLeadTrainer
          ? formatTrainerLink(data?.selectedLeadTrainer)
          : '-',
      },
      {
        label: 'Assistant Trainer',
        value: data?.selectedAssistantTrainer
          ? formatTrainerLink(data?.selectedAssistantTrainer)
          : '-',
      },
      {
        label: 'Supporting Staff',
        value:
          data?.selectedSupport?.length > 0
            ? renderSupportinStaffLinks(data?.selectedSupport)
            : '-',
      },
      {
        label: 'Trainers preselected',
        value: `${data.preselectMode}`,
      },
      {
        label: 'Number of invited trainers',
        value: data?.trainers?.length,
      },
    ];

    return Children.toArray(
      formattedData.map(({ label, value }) => (
        <Space>
          <Text type="secondary">{label}</Text>
          <Text strong>{value}</Text>
        </Space>
      ))
    );
  };

  return (
    <section className="grey-section">
      <Title level={5}>{title}</Title>
      <Space direction="vertical">{renderItems()}</Space>
    </section>
  );
};

AnnouncementInfo.propTypes = {
  data: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
};

export default AnnouncementInfo;
